<template>
<div>
    <div class="pay" :class="{show: showPay}">
        <div class="success" :class="{show: showSuccess}">
            <div class="icon">
              <img src="../assets/img2/success.png" alt="">
            </div>
            <div class="str">支付成功</div>
            <div class="info">
              三秒后自动回到订单页面，未返回
              <span class="link" @click="manualBack">点击此处</span>
            </div>
        </div>
        <div class="pay-i" :class="{show: showBody}">
          <div class="header">
              <span class="str">确认支付</span>
              <span class="close el-icon-close" @click="cancel"></span>
          </div>
          <div class="pay_body">
              <div class="pay_row">
                <div>购买套餐：</div>
                <div class="title">{{mealInfo.setMelName}}</div>
              </div>
              <div class="pay_row">
                <div>支付金额：</div>
                <div class="payPrice">${{(mealInfo.payAmount || 0).toFixed(2)}}</div>
              </div>
              <div class="pay_row">
                <div>可用余额：</div>
                <div class="payPrice">${{$store.state.userInfo.balance}} <span class="link" @click="recharge">充值</span></div>
              </div>
              <div class="pay_row">
                <div>剩余支付时间：</div>
                <div class="countdown">
                  <span v-if="mealInfo.countTimeDesc">{{mealInfo.countTimeDesc}}</span>
                  <span v-else style="color:#ccc">已过期</span>
                </div>
              </div>
              <div class="operation">
                  <div>
                    <el-button class="confirmPay" type="primary" @click="pay" :loading="loading" 
                      :disabled="!mealInfo.countTimeDesc">确认支付</el-button>
                  </div>
                  <div class="cancelBox">
                    <span class="cancel" @click="cancel">取消</span>
                  </div>
              </div>
          </div>
        </div>
    </div>
    
    <cdkey ref="cdkey" :payCallback="callback"></cdkey>
</div>
</template>

<script>
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import moment from "moment";
import cdkey from "@/components/cdkey";
import recharge from "@/public/method/recharge";

// RxJS v6+
import { interval, } from 'rxjs';

const source = interval(1000);
export default {
  name: 'pay',
  components:{
    cdkey
  },
  data(){
    return {
      showPay: false,
      mealInfo:{
        setMelName:"",
        payAmount:0,
        countTimeDesc:"30:00",
        orderId:"",
        orderCode:"",
        subscribe:undefined
      },
      showBody: true,
      showSuccess: false,
      timer: null,
      loading: false,

    }
  },
  props: {
    callback: Function,
    cancelCallback: Function
  },
  methods:{
      recharge,
      pay(){
        var balance = this.$store.state.userInfo.balance;
        if(balance < this.mealInfo.payAmount){
          return this.$message({
            message:"余额不足，请充值，如已充值请刷新页面重试。",
            type:"warning",
            showClose: true
          });
        }
        var params = {
            orderId: this.mealInfo.orderId,
            orderCode: this.mealInfo.orderCode,
        };
        this.loading = true;
        server.payOrder(params).then(data=>{
            if(data.reCode === SUCCESS_CODE){
                // this.
                this.unsubscribe();
                this.showPay = false;
                setTimeout(()=>{
                  // this.finish();
                  this.createdCDKEY()
                },500)
            };
        })
      },
      manualBack(){
        this.unsubscribe();
        clearTimeout(this.timer);
        if(this.callback){
          this.callback();
          this.showPay = false;
        }else{
          this.showPay = false;
        }
      },
      cancel(){
          // this.finish();
          this.showPay = false;
          this.unsubscribe();
          if(this.cancelCallback){
            this.cancelCallback();
          }
      },
      show(_meal){
        if(!_meal || !_meal.orderId || !_meal.orderCode) return;
        
        var meal = Object.assign({},_meal,{subscribe:undefined});
        meal.countTimeDesc = "30:00"
        meal.subscribe = source.subscribe(()=>{
            var time = meal.lastTime - (moment().format("x")*1);
            if(time > 0){
              meal.countTimeDesc = moment(time).format("mm:ss");
            }else{
              meal.countTimeDesc = "";
              meal.subscribe.complete();
            };
            console.log("meal",meal,this.mealInfo);
        })
        meal.payAmount = meal.payment || meal.discountPrice || meal.originalPrice || 0;
        this.mealInfo = meal;
        this.showPay = true;
        this.showBody = true;
        this.showSuccess = false;
      },
      finish(){
        this.showSuccess = true;
        this.unsubscribe();
        this.loading = false;
        this.showPay = false;
        this.timer = setTimeout(()=>{
          if(this.callback){
            this.callback();
            this.showPay = false;
          }else{
            this.showPay = false;
          }
        },3000)
      },
      createdCDKEY(){
        this.$refs.cdkey.show(this.mealInfo.orderId,{isPay: true});
      },
      unsubscribe(){
        if(this.mealInfo.subscribe){
          this.mealInfo.subscribe.complete();
        }
      }
  },
  created(){
    console.log("pay component",this.callback);
  },
  destroyed(){
    this.unsubscribe(); 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pay{
  .link{
      color: #3FB8A4;
    text-decoration: underline;
    cursor: pointer;
    &:hover{color:#359b8a}
  }
  position: fixed;
  width: 100vw;
  height:100vh;
  left:0;top:0;
  background:rgba(0,0,0,0.4);
  transform: translateY(100%);
  opacity: 0;
  z-index: 99;
  display:flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s;
  &.show{
    transform: translateY(0px);
    opacity: 1;
  }
  .success{
    max-width:450px;
    width:80%;
    background:#fff;
    padding:5%;
    text-align: center;
    .icon{
      text-align: center;
    }
    .str{
      color:#3FB8A4;
      font-weight: bold;
      font-size:24px;
      margin:4% 0;
    }
    .info{
      text-align: center;
    }
    transition: 0.5s opacity;
      opacity: 0;
      transform:translateY(100vh);
      position:absolute;
    &.show{
      opacity: 1;
      transform:translateY(0);
      position:relative;
    }
  }
  .pay-i{
    max-width:450px;
    width:80%;
    background:#fff;
    .pay_body{
      padding:5% 0;
    }
    .header{
      line-height:48px;
      justify-content: space-between;
      padding:0 15px;
      border-bottom:1px solid #ddd;
      display: flex;
      align-items: center;
      .str{
        font-size:18px;
        font-weight: bold;
      }
      .close{
        transition: all 0.5s;
        &:hover{
          transform: rotate(360deg);
        }
      }
    }
    .pay_row{
      display:flex;
      align-items: center;
      padding: 8px 5%;
      // .title{}
    }
    .operation{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top:5%;
        .confirmPay{
          padding-left: 30px;
          padding-right: 30px;
        }
      .cancelBox{
        margin-top:2%;
        .cancel{
          cursor: pointer;
        }
      }
    }
    transition: 0.5s opacity;
    opacity: 0;
    transform:translateY(100vh);
    position:absolute;
    &.show{
      opacity: 1;
      transform:translateY(0);
      position:relative;
    }
  }
}

</style>
